import * as yup from "yup";
import { ApiHelper } from "../../utills/helpers";

export const ProfileDetailsValidations = yup.object().shape({
  username: yup
    .string()
    .trim()
    .required("Please enter username.")
    .test(
      "validateDuplicateUsername",
      "This username is not available.",
      async function (username: any) {
        const { path, createError } = this;
        const {
          isError,
          messages,
        } = await new ApiHelper().FetchFromServer(
          "/auth",
          "/validate-username",
          "get",
          true,
          { username }
        );
        if (!isError) {
          return true;
        }
        return createError({
          path,
          message: messages[0] || "This username is not available.",
        });
      }
    ),
  firstName: yup.string().trim().required("Please enter first name."),
  lastName: yup.string().trim().required("Plesae enter last name"),
  phoneNumber: yup
    .string()
    .trim()
    .notRequired()
    .min(10, "Phone number should be at least of 10 character.")
    .max(13, "Phone number should not be more than 13 character."),
  gender: yup
    .string()
    .trim()
    .notRequired()
    .oneOf(["male", "female", "other"], "Invalid gender."),
  address: yup.string().trim().optional(),
  state: yup.string().trim().optional(),
  city: yup.string().trim().optional(),
  pincode: yup
    .string()
    .trim()
    .notRequired()
    .length(6, "Pin code should be of 6 digits."),
  about: yup.string().trim().optional(),
});
